<template>
  <div :class="['fixed-footer']">
    <div class="fixed-footer--left">
      <DemandePrint />
      <BasicButton
        v-if="canDelete && !mustConfirm"
        icon-name="trash"
        type="danger"
        variant="outlined"
        size="small"
        @click="$emit('delete')"
      />
    </div>
    <div class="fixed-footer--right">
      <template v-if="mustConfirm">
        <BasicButton
          label="Reprendre la saisie de la demande"
          size="small"
          @click="$emit('accept')"
        />
        <BasicButton
          label="Refuser la demande"
          type="danger"
          variant="outlined"
          size="small"
          @click="$emit('refuse')"
        />
      </template>
      <template v-else>
        <BasicButton
          label="Enregistrer"
          size="small"
          @click="$emit('save')"
        />
        <BasicButton
          label="Transmettre"
          type="reverse"
          variant="outlined"
          size="small"
          @click="$emit('transmit')"
        />
        <BasicButton
          v-if="canRefuse"
          label="Refuser"
          type="danger"
          variant="outlined"
          size="small"
          @click="$emit('refuse')"
        />
      </template>
    </div>
  </div>
</template>

<script setup lang="ts">
  import DemandePrint from '@/features/interface/demande/shared/components/demande-print/DemandePrint.vue'
  defineProps<{ mustConfirm: boolean; canRefuse: boolean; canDelete: boolean }>()
  defineEmits(['save', 'transmit', 'accept', 'refuse', 'delete'])
</script>

<style scoped lang="less">
  @import 'DemandeFooter.less';
</style>
